import { range } from 'lodash';

import * as OvationsApi from 'core/ovations-api';

import { dateTimeCurrent } from 'core/util/datetime';

export const details: OvationsApi.Types.FieldUpdate[] = [
    {
        newValue: dateTimeCurrent(),
        oldValue: dateTimeCurrent(),
        propertyName: 'Submission Date',
        newFileName: null,
        oldFileName: null,
        newValueUrl: null,
        oldValueUrl: null,
        reason: null,
    },
    {
        newValue: '6',
        oldValue: '9',
        propertyName: 'Quantity',
        newFileName: null,
        oldFileName: null,
        newValueUrl: null,
        oldValueUrl: null,
        reason: null,
    },
];

export const mockClaimHistory: OvationsApi.Types.ClaimHistory[] = range(1, 4).map(() => ({
    date: dateTimeCurrent(),
    changedBy: 'Test Person',
    details,
    notes: null,
    isNotification: false,
    historyNotification: null,
}));

export default mockClaimHistory;
